import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AdministracionSnapshot,
  MiembroAdminSnapshot,
} from '../../models/constitution-snapshot.model';
import { ConstitutionReadonlyFieldComponent } from '../shared/constitution-readonly-field.component';

@Component({
  selector: 'app-constitution-administration-readonly-table',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ConstitutionReadonlyFieldComponent],
  templateUrl: './constitution-administration-readonly-table.component.html',
  styleUrl: '../../../constitution-form/constitution-form.component.scss',
})
export class ConstitutionAdministrationReadonlyTableComponent {
  administracion = input.required<AdministracionSnapshot>();

  memberSelected = output<MiembroAdminSnapshot>();

  onRowClick(miembro: MiembroAdminSnapshot): void {
    this.memberSelected.emit(miembro);
  }

  onRowKeydown(event: KeyboardEvent, miembro: MiembroAdminSnapshot): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.memberSelected.emit(miembro);
    }
  }
}
